module.exports = __webpack_public_path__ + "assets/img/green-tick.22bf968d.svg";